import { UAParser } from 'utils';

export default {
  data: {},
  meta: {
    title: '', // 标题
    userAgent: UAParser()
  },
  ui: {
    loading: false // 当前是否有异步请求处理
  },
  user: {}
};
